import {Link} from 'react-router-dom';
import {ReactNode} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useIsDarkMode} from '@common/ui/themes/use-is-dark-mode';
import authBgSvg from './auth-bg.svg';
import {useTrans} from '@common/i18n/use-trans';
import {useSettings} from '@common/core/settings/use-settings';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}
export function AuthLayout({heading, children, message}: AuthPageProps) {

//window.location.href="https://www.itaskboard.com/logout";
//window.location.replace("https://www.itaskboard.com/logout");

  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();
  const {trans} = useTrans();

  return (
    <main
      className="h-screen flex flex-col items-center bg-alt dark:bg-none pt-70 px-14 md:px-10vw overflow-y-auto"
      style={{backgroundImage: isDarkMode ? undefined : `url("${authBgSvg}")`}}
    >
      <Link
        //to="/"
        target="_blank"
        to="https://www.interactiveshell.com/login"
        className="block flex-shrink-0 mb-40"
        aria-label={trans({message: 'Go to homepage'})}
      >
        <img
          src={isDarkMode ? branding.logo_light : branding?.logo_dark}
          className="block h-42 w-auto m-auto"
          alt="logo"
        />
      </Link>
            <div className="rounded-lg max-w-440 pl-40 px-40 pt-40 pb-40 w-full mx-auto bg-paper">
        <p className="text-md">To access IDE Drive <b><a href="https://www.interactiveshell.com/login" target="_blank;">Login</a></b> and then reload this page.</p>
        {children}
      </div>
    </main>
  );
}
